import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const viewCount = comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views.toString();

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 免费韩国漫画在线阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          width={400}
          height={560}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <span
          className={`absolute top-2 right-2 text-xs font-medium px-2 py-0.5 rounded-full ${
            comic.status === '更新中'
              ? 'bg-primary-500 text-white'
              : 'bg-secondary-500 text-white'
          }`}
        >
          {comic.status}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
          <span className="text-white text-xs bg-primary-500/90 px-3 py-1.5 rounded-full cursor-pointer whitespace-nowrap">
            立即阅读
          </span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
        {comic.title}
      </h3>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-xs text-foreground-500">{comic.author}</span>
        <span className="text-xs text-foreground-400">·</span>
        <span className="text-xs text-accent-500 font-medium">{comic.rating}</span>
        <div className="w-3 h-3 flex items-center justify-center">
          <i className="ri-star-fill text-[10px] text-accent-500"></i>
        </div>
      </div>
      <p className="text-xs text-foreground-500 mt-0.5">{viewCount} 次阅读</p>
    </Link>
  );
}